import { render } from "./EditSelection.vue?vue&type=template&id=150e152d&scoped=true"
import script from "./EditSelection.vue?vue&type=script&lang=js"
export * from "./EditSelection.vue?vue&type=script&lang=js"

import "./EditSelection.vue?vue&type=style&index=0&id=150e152d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150e152d"]])

export default __exports__